document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", function () {
    const header = document.querySelector(".rouge-header");
    // ここでヘッダーの高さを取得する
    const headerHeight = header.offsetHeight;
    const scrollY = window.pageYOffset;

    if (scrollY >= 100) {
      // 100pxスクロール後にheader-fixedを付与する
      header.classList.add("rouge-header-fixed");
      // ヘッダーと同じ高さ分の余白をbodyに設置
      document.body.style.marginTop = headerHeight + "px";
    } else {
      header.classList.remove("rouge-header-fixed");
      // 先ほど入れた余白をリセットする
      document.body.style.marginTop = "0";
    }
  });

  const overlay = document.querySelector(".common-modal-overlay");
  const body = document.body;

  // メガメニュー開閉処理
  document
    .querySelectorAll(".rouge-header__list.has-megamenu")
    .forEach((item, index) => {
      const trigger = item.querySelector("a");
      const megamenu = document.querySelectorAll(".rouge__magamenu")[index];

      trigger.addEventListener("click", (e) => {
        e.preventDefault();

        const isOpen = item.classList.contains("is-open");

        // 全部閉じる
        document
          .querySelectorAll(".rouge-header__list.has-megamenu")
          .forEach((el) => el.classList.remove("is-open"));
        document
          .querySelectorAll(".rouge__magamenu")
          .forEach((mm) => mm.classList.remove("is-open"));

        if (!isOpen) {
          // 自分を開く
          item.classList.add("is-open");
          if (megamenu) megamenu.classList.add("is-open");

          // オーバーレイ表示＋スクロール禁止
          overlay?.classList.add("is-active");
          body.classList.add("no_scroll");
        } else {
          // 既に開いてた → 閉じたのでオーバーレイも非表示に
          overlay?.classList.remove("is-active");
          body.classList.remove("no_scroll");
        }
      });
    });

  // 閉じるボタン処理
  document.querySelectorAll("#rouge-close-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const megamenu = btn.closest(".rouge__magamenu");
      if (megamenu) megamenu.classList.remove("is-open");

      document
        .querySelectorAll(".rouge-header__list.has-megamenu.is-open")
        .forEach((el) => el.classList.remove("is-open"));

      overlay?.classList.remove("is-active");
      body.classList.remove("no_scroll");
    });
  });

  // オーバーレイクリックでメガメニュー全閉
  if (overlay) {
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) {
        document
          .querySelectorAll(".rouge__magamenu")
          .forEach((mm) => mm.classList.remove("is-open"));
        document
          .querySelectorAll(".rouge-header__list.has-megamenu.is-open")
          .forEach((el) => el.classList.remove("is-open"));

        overlay.classList.remove("is-active");
        body.classList.remove("no_scroll");
      }
    });
  }
});

/*ハンバーガーメニュー
 ***************************************************************/
document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.querySelector(".openbtn");
  const spMenu = document.querySelector(".sp-menu");
  const menuItems = document.querySelectorAll(".sp-menu-list-item");
  const rougeAnnouncement = document.querySelector(".rouge-announcement");
  const rougeHeader = document.querySelector("#rouge-header");
  const body = document.body;
  // 非表示要素は高さ0とみなす
  function getVisibleHeight(element) {
    if (!element) return 0;
    const style = window.getComputedStyle(element);
    return style.display !== "none" ? element.offsetHeight : 0;
  }
  // spMenuのtopを更新
  function updateSpMenuTop() {
    const announcementHeight = getVisibleHeight(rougeAnnouncement);
    const headerHeight = getVisibleHeight(rougeHeader);
    const totalHeight = announcementHeight + headerHeight;
    spMenu.style.top = `${totalHeight}px`;

    // デバッグ用
    console.log(
      "announcement:",
      announcementHeight,
      "header:",
      headerHeight,
      "total:",
      totalHeight
    );
  }
  // メニュー開閉
  openBtn.addEventListener("click", function () {
    this.classList.toggle("active");
    spMenu.classList.toggle("show");

    if (spMenu.classList.contains("show")) {
      body.classList.add("no_scroll");
      updateSpMenuTop(); // ← 開いたタイミングでtop再計算
    } else {
      body.classList.remove("no_scroll");
    }
  });
  // メニュー内リンククリック時に閉じる
  menuItems.forEach((item) => {
    item.addEventListener("click", function () {
      openBtn.classList.remove("active");
      spMenu.classList.remove("show");
      body.classList.remove("no_scroll");
    });
  });

  // スクロールでヘッダー固定
  window.addEventListener("scroll", function () {
    const scrollY = window.pageYOffset;
    const headerHeight = getVisibleHeight(rougeHeader);
    const spMenu = document.querySelector(".sp-menu");

    if (scrollY >= 100) {
      rougeHeader.classList.add("rouge-header-fixed");
      document.body.style.marginTop = headerHeight + "px";
    } else {
      rougeHeader.classList.remove("rouge-header-fixed");
      document.body.style.marginTop = "0";
    }

    // メニュー開いてるときは .sp-menu の top を再設定
    if (spMenu.classList.contains("show")) {
      spMenu.style.top = headerHeight + "px";
    } else {
      spMenu.style.top = ""; // 開いてないときはリセットしておくと安心
    }
  });

  // ウィンドウリサイズ対応
  window.addEventListener("resize", function () {
    if (spMenu.classList.contains("show")) {
      updateSpMenuTop();
    }
  });
  // 初期化
  updateSpMenuTop();
});

// document.addEventListener("DOMContentLoaded", function () {
//   const openBtn = document.querySelector(".openbtn");
//   const spMenu = document.querySelector(".sp-menu");
//   const menuItems = document.querySelectorAll(".sp-menu-list-item");
//   const rougeAnnouncement = document.querySelector(".rouge-announcement");
//   const rougeHeader = document.querySelector("#rouge-header");
//   const body = document.body; // ★ここ追加！

//   openBtn.addEventListener("click", function () {
//     this.classList.toggle("active");
//     spMenu.classList.toggle("show");

//     // ★ sp-menuが開いてたらno_scrollを付与、閉じたら外す
//     if (spMenu.classList.contains("show")) {
//       body.classList.add("no_scroll");
//     } else {
//       body.classList.remove("no_scroll");
//     }
//   });

//   menuItems.forEach((item) => {
//     item.addEventListener("click", function () {
//       openBtn.classList.remove("active");
//       spMenu.classList.remove("show");
//       body.classList.remove("no_scroll"); // ★メニュー項目クリックでも解除
//     });
//   });

//   // .rouge-announcement と #rouge-header の高さを取得して合計
//   const announcementHeight = rougeAnnouncement
//     ? rougeAnnouncement.offsetHeight
//     : 0;
//   const headerHeight = rougeHeader ? rougeHeader.offsetHeight : 0;
//   const totalHeight = announcementHeight + headerHeight;

//   // .sp-menu の top を設定
//   spMenu.style.top = `${totalHeight}px`;
// });

/* ハンバーガーメニュー内のアコーディオン
 ***************************************************************/
document.addEventListener("DOMContentLoaded", function () {
  const accordionToggles = document.querySelectorAll(".has-accordion");

  accordionToggles.forEach(function (toggle) {
    toggle.addEventListener("click", function (e) {
      e.preventDefault(); // リンク動作無効（必要なら）

      const accordion = toggle.nextElementSibling; // .rouge__accordionを取得

      if (accordion && accordion.classList.contains("rouge__accordion")) {
        accordion.classList.toggle("is-open");
        toggle.classList.toggle("open"); // ← .has-accordionにも.openクラスを付与
      }
    });
  });
});

/* 検索モーダル
 ***************************************************************/
document.addEventListener("DOMContentLoaded", function () {
  const openButton = document.getElementById("rouge-search");
  const searchModal = document.getElementById("rouge-search-modal");
  const overlay = document.querySelector(".common-modal-overlay");
  const body = document.body;
  const closeButton = document.getElementById("rouge-search-close-btn"); // ★追加！

  openButton.addEventListener("click", function () {
    searchModal.classList.add("is-active");
    overlay.classList.add("is-active");
    body.classList.add("no_scroll");
  });

  overlay.addEventListener("click", function () {
    searchModal.classList.remove("is-active");
    overlay.classList.remove("is-active");
    body.classList.remove("no_scroll");
  });

  // ★閉じるボタン押したときの処理
  closeButton.addEventListener("click", function () {
    searchModal.classList.remove("is-active");
    overlay.classList.remove("is-active");
    body.classList.remove("no_scroll");
  });

  // 商品詳細ページアコーディオン
  const items = document.querySelectorAll(".rouge-product__accordion-item");

  items.forEach((item) => {
    const title = item.querySelector(".rouge-product__accordion-title");
    const content = item.querySelector(".rouge-product__accordion-text");

    title.addEventListener("click", () => {
      content.classList.toggle("is-open");
      item.classList.toggle("open");
    });
  });

  // 商品詳細ページタブ
  // const tabs = document.querySelectorAll(".js-tab");
  // const contents = document.querySelectorAll(".js-content");

  // tabs.forEach((tab, index) => {
  //   tab.addEventListener("click", function () {
  //     // タブのcurrentクラスを切り替え
  //     tabs.forEach((t) => t.classList.remove("current"));
  //     this.classList.add("current");

  //     // コンテンツの表示切り替え
  //     contents.forEach((c) => (c.style.display = "none"));
  //     contents[index].style.display = "block";
  //   });
  // });

  // // 初期表示：最初のタブ以外を非表示に
  // contents.forEach((c, i) => {
  //   c.style.display = i === 0 ? "block" : "none";
  // });
});

// ROUGE: カートドロワー/モーダル表示中は、右下のチャット吹き出し等の追従ウィジェットを隠す
// （購入手続きボタンとの重なり防止。閉じれば自動で元に戻る。該当要素が無ければ何もしない）
;(function () {
  var CHAT_SEL = [
    '#shopify-chat',
    '[id*="shopify-chat"]',
    '[class*="shopify-chat"]',
    '[id*="inbox-chat"]',
    '[class*="inbox-chat"]',
    'iframe[src*="shopify-chat"]',
    'iframe[src*="shopifychat"]',
    'iframe[title*="チャット"]',
    'iframe[title*="chat" i]'
  ].join(',');

  // 購入導線は絶対に触らない（カート/チェックアウト内の要素は保護）
  var PROTECT_SEL = 'cart-drawer, #CartDrawer, cart-notification, form[action*="/cart"], [name="checkout"], [class*="checkout"], [class*="cart__"]';

  function toggleWidgets(hide) {
    try {
      document.querySelectorAll(CHAT_SEL).forEach(function (el) {
        if (el.closest(PROTECT_SEL)) return; // カートドロワー内などは隠さない
        el.style.setProperty('visibility', hide ? 'hidden' : '', 'important');
        el.style.setProperty('pointer-events', hide ? 'none' : '', 'important');
      });
    } catch (e) {}
  }

  function check() {
    toggleWidgets(document.body.classList.contains('overflow-hidden'));
  }

  document.addEventListener('DOMContentLoaded', function () {
    check();
    new MutationObserver(check).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  });
})();
